import { isNil } from 'lodash-es';
import { Resource } from '../Resource';
import * as methods from '../methods';
import * as transformers from '../transformers';
import { deviceMutationExternalInvalidationKeys } from './devices';
import { fromRawPlotToPlot, plotMutationExternalInvalidationKeys } from './plots';
import { fromRawStationToStation, stationsMutationExternalInvalidationKeys } from './stations';
const rootPath = 'plots_and_stations';
export var RawMyFarmItemType;
(function (RawMyFarmItemType) {
    RawMyFarmItemType[RawMyFarmItemType["plot"] = 0] = "plot";
    RawMyFarmItemType[RawMyFarmItemType["station"] = 1] = "station";
})(RawMyFarmItemType || (RawMyFarmItemType = {}));
export const fromRaw = (rawItem) => {
    if (rawItem.type === RawMyFarmItemType.plot) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { type, ...rawPlot } = rawItem;
        return fromRawPlotToPlot(rawPlot);
    }
    else {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { type, ...rawStation } = rawItem;
        return fromRawStationToStation(rawStation);
    }
};
const myFarm = Resource((requesterBuilder) => {
    const createGetMany = (query) => {
        const newRequester = requesterBuilder({
            path: rootPath,
            requestCtx: {
                transform: transformers.paginatedResponse(fromRaw),
                params: {
                    query: {
                        archived: query?.isArchived,
                        available_options: query?.availableOptions,
                        id__in: !isNil(query?.ids) ? query?.ids.join(',') : undefined,
                        favorite: query?.isFavorite,
                        limit: query?.limit,
                        metrics__in: query?.metrics,
                        metrics_op: query?.metricOperator,
                        offset: query?.offset,
                        organization: query?.organizationId,
                        q: query?.q,
                        type: query?.itemType,
                        universe: query?.universe,
                        virtual_device: query?.hasVirtualDevice,
                        with_shape: query?.withShape,
                        sort_by: query?.sortBy,
                        sort_order: query?.sortOrder
                    }
                }
            }
        });
        deviceMutationExternalInvalidationKeys.add(newRequester.key[0]);
        stationsMutationExternalInvalidationKeys.add(newRequester.key[0]);
        plotMutationExternalInvalidationKeys.add(newRequester.key[0]);
        return newRequester;
    };
    const getMany = createGetMany;
    return {
        getMany,
        getAllPages: methods.getAllPages({ getMany }),
        getPage: methods.getPage({
            getMany
        })
    };
});
export default myFarm;
